// extracted by mini-css-extract-plugin
export default {"contactName":"JgHPIEkOz45EY1Pv3efg","contactNameAvatar":"OANF0_Libjg18p6N9IWr","contactNameCaption":"L1Bg_faUfNwzePgKf38S"};